// TODO: see last5.js

import * as constants from '../constants';

const circleRadius = 22;
const circleStrokeWidth = 2;

export default function ( result ) {
  const c = new PIXI.Container();
  const g = new PIXI.Graphics();
  c.addChild(g);

  g
  .beginFill(result ? constants.green : constants.red)
  .drawCircle(0, 0, circleRadius)
  .endFill();

  const resultText = new PIXI.Text(result ? constants.tick : constants.cross, {
    font: '36px Flaticons Stroke',
    fill: 0xFFFFFF,
    align: 'center'
  });
  c.addChild(resultText);

  resultText.anchor.set(0.5);
  resultText.y = 3;

  return c;
};
